module.exports = __webpack_public_path__ + "static/media/lightBg.92bf1ceb.png";